module.exports = __webpack_public_path__ + "img/poor-power.864ec79a.svg";